const isLocationGuidePage = (templateId: string): boolean => {
  const locationGuideTemplateIds = [
    "6738B93E-2144-4170-884D-BFB55EEC10CB",
    "29A4BC6C-68FB-4A44-9273-7AFE3972919C",
    "885627E2-6A81-4EE3-B2ED-E46E01FF93D4",
    "8BCB34C1-0481-426C-BB95-A552720FDB55",
  ];
  return locationGuideTemplateIds.includes(templateId);
};

export const getLocationGuideCtas = (
  sxaTags?: Array<{ fields?: { Title?: { value: string } } }>,
) => {
  return (
    sxaTags
      ?.filter((tag) => tag.fields?.Title?.value)
      .map((tag) => ({
        type: "button" as const,
        miniCtaButtonProps: {
          label: tag.fields?.Title?.value ?? "",
          variant: "tertiary" as const,
          unclickable: true,
        },
      })) ?? undefined
  );
};

export { isLocationGuidePage };
